export const authKeys = {
  all: ['auth'] as const,
  currentProviderRoot: ['provider', 'current'] as const,
  currentProvider: (subject: string | null | undefined) =>
    [...authKeys.currentProviderRoot, subject ?? null] as const,
  userPreferredLocale: (subject: string | null | undefined) =>
    ['user', 'preferred-locale', subject ?? null] as const,
} as const;
